export default "__VITE_ASSET__f5715b1b__"